import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-bs-delay"]
const _hoisted_2 = { class: "toast-header" }
const _hoisted_3 = {
  class: "bd-placeholder-img rounded me-2",
  width: "20",
  height: "20",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  preserveAspectRatio: "xMidYMid slice",
  focusable: "false"
}
const _hoisted_4 = ["fill"]
const _hoisted_5 = { class: "me-auto" }
const _hoisted_6 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_7 = { class: "toast-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    ref: "toast",
    class: "toast",
    "data-bs-delay": _ctx.delay,
    role: "alert",
    "aria-live": "assertive",
    "aria-atomic": "true"
  }, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock("svg", _hoisted_3, [
        _createElementVNode("rect", {
          width: "100%",
          height: "100%",
          fill: _ctx.BsFixedColor[_ctx.alert.type]
        }, null, 8, _hoisted_4)
      ])),
      _createElementVNode("strong", _hoisted_5, _toDisplayString(_ctx.alert.title), 1),
      (_ctx.alert.sub)
        ? (_openBlock(), _createElementBlock("small", _hoisted_6, _toDisplayString(_ctx.alert.sub), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.alert.message), 1)
  ], 8, _hoisted_1))
}